import React from "react";
import { RCCMicrosoftSocialLoginProvider } from "react-common-components";

const MicrosoftSocialLogin: React.FC = ({children}) => <RCCMicrosoftSocialLoginProvider clientId="dccca409-742d-4322-9d86-5173dcfa03e2">
	{children}
</RCCMicrosoftSocialLoginProvider>;

export default MicrosoftSocialLogin;
